export default [
  {
    title: 'Digital Invoicing',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Unit of Measure',
        route: 'unit-of-measure-list',
      },
      {
        title: 'Item Group',
        route: 'item-group-list',
      },
    ],
  },
];
